
import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row, Spinner, Stack, Table, Form, Modal, FormGroup, FormLabel } from "react-bootstrap";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
import Select from "react-select";

import { Link, useNavigate } from "react-router-dom";
import { isMobile, BrowserView } from "react-device-detect";

import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import { ROUTES } from "../../constants/webRouting";
import DateRangePicker from 'rsuite/DateRangePicker';
// (Optional) Import component styles. If you are using Less, import the `index.less` file. 
import 'rsuite/DateRangePicker/styles/index.css';
import ".././../assets/css/ListComponentsTable.css";
import { formatDate, formatDateForView, getUserDetails } from "../../utils/helper";
import InfoPill from "../InfoPill";
import * as constants from "../../constants/CONSTANT";
import PERMISSIONS from "../../constants/permissions";
import UserMultiSelect from "../common/UserMultiSelect";
import moment from "moment";//Added by shahir hussain 31-12-2025
import PubSub from "pubsub-js";


const OrderAmcList = () => {
    const userInfo = getUserDetails();
    const navigate = useNavigate();
    const [body, setBody] = useState();
    const [dateRange, setDateRange] = React.useState([
        // new Date(),
        // new Date()
    ]);
    //Imran Khan 25-02-2026 Added new state for AMC Upto Date Range Filter.
    const [amcUptoDateRange, setAmcUptoDateRange] = React.useState([]);

    const [filterData, setFilterData] = useState({ amc_status: "AMC Running" });
    const [orderValues, setOrderValues] = useState([]);

    const [statusArray, setStatusArray] = useState(
        constants.AMC_STATUS_VALUES
    );
    const [assignUsers, setAssignUsers] = useState([]);

    //Added this all by shahir hussain 31-12-2025
    const [changeOwnerModal, setChangeOwnerModal] = useState(false);
    const [refreshRecords, setRefreshRecords] = useState(false);
    const [ownerLeads, setOwnerLeads] = useState([]);
    const [ownerLeadsHeader, setOwnerLeadsHeader] = useState([]);
    const [fromUser, setFromUser] = useState({});
    const [toUser, setToUser] = useState({});
    const tableRef = useRef(null);
    const [users, setUsers] = useState([]);
    const [spinnerForChangeOwner, setSpinnerForChangeOwner] = useState(false);
    const [leadCities, setLeadCities] = useState([]);
    const [selectedToUsers, setSelectedToUsers] = useState([]);
    //Ended this all by shahir hussain 31-12-2025

    //Imran Khan 25-02-2026 Added warranty end date range and created date range in dependency array for filter.
    useEffect(() => {
        const filter = { ...filterData };
        delete filter.owner_name;
        delete filter.offer_name_label;
        filter.owner_ids = filter?.owner_ids?.filter((item) => (item.value))?.map((item) => item.value);
        if (Array.isArray(dateRange) && dateRange.length > 0) filter.date_range = { filed: 'createddate', createddate: { from: formatDate(dateRange?.at(0) || null), to: formatDate(dateRange?.at(1) || null), } };
        if (Array.isArray(amcUptoDateRange) && amcUptoDateRange.length > 0)
        filter.amc_upto_range = {
            filed: 'end_date',
            end_date: {
            from: formatDate(amcUptoDateRange?.at(0) || null),
            to: formatDate(amcUptoDateRange?.at(1) || null),
            }
        };
        fetchOrderAmcs(filter);
    }, [dateRange, filterData, amcUptoDateRange]);


    async function init() {
        if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some(permission => {
            return userInfo?.permissions?.map(p => p.name).includes(permission);
        })) {
            const resultedUsers = await fuziElevatorsApi.fetchUsers();
            resultedUsers &&
                Array.isArray(resultedUsers) &&
                setAssignUsers(
                    resultedUsers.map((user) => ({
                        value: user.id,
                        label: user.username,
                    }))
                );
        }
        if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_ORDER].some(permission => {
            return userInfo?.permissions?.map(p => p.name).includes(permission);
        })) {
            fuziElevatorsApi.fetchOrders().then((result) => {
                (result && Array.isArray(result)) &&
                    setOrderValues(
                        result?.map((item) => ({
                            id: item?.id,
                            name: `${item?.offer_name_label || ""}`,
                        }))
                    );
            });
        }
    }
    async function fetchOrderAmcs(filters) {
        const result = await fuziElevatorsApi.fetchOrderAmcs(filters);
        if (result) {
            setBody(result);
        } else {
            setBody([]);
        }
    }
    useEffect(() => {
        init();
    }, []);

    // Create table headers consisting of 4 columns.
    // Randomize data of the table columns.
    // Note that the fields are all using the `prop` field of the headers.
    const header = [];
    if (!isMobile) {
        header.push(
            {
                title: "Order",
                prop: "offer_name_label",
                isFilterable: true,
                cell: (row) => (
                    <Link to={`${ROUTES.ORDER_AMC.LIST}/${row.id}`} state={row}>
                        {row.offer_name_label}
                    </Link>
                ),
                isSortable: true,
            },
            //formatDateForView added by shahir hussain 27-08-2025
            { title: "Site Address", prop: "site_address", isFilterable: true },
            { title: "City", prop: "city", isFilterable: true },
            { title: "Phone", prop: "phone", isFilterable: true },
            { title: "AMC Start Date", prop: "start_date", cell: (row) => formatDateForView(row.start_date), isFilterable: true },
            { title: "AMC Upto", prop: "end_date", cell: (row) => formatDateForView(row.end_date), isFilterable: true, isSortable: true, },
            // { title: "AMC Status", prop: "amc_status", isFilterable: true },
            {
                title: "AMC Status",
                prop: "amc_status",
                isFilterable: true,
                isSortable: true,
                alignment: { horizontal: "center" },
                cell: (row) => (
                    <span
                        className="badge rounded-pill w-100"
                        style={getStatusClass(row.amc_status)}
                    >
                        {row.amc_status}
                    </span>
                ),
            },
            { title: "Parts Type", prop: "parts_type", isFilterable: true },

        );
        [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PAYMENT].some(permission => {
            return userInfo?.permissions?.map(p => p.name).includes(permission);
        }) && (header.push({ title: "AMC price", prop: "amc_total_amount", isFilterable: true }));

        header.push(
            { title: "Payment Status", prop: "payment_status", isFilterable: true },
            { title: "Payment Mode", prop: "payment_mode", isFilterable: true },
            { title: "Payment Frequency", prop: "payment_frequency", isFilterable: true },
            // { title: "Company Name", prop: "company_name", isFilterable: true },
            // {
            //     title: 'Assign User',
            //     prop: 'owner_name',
            //     isFilterable: true,
            //     cell: (row) => (
            //         <Link to={ROUTES.USER + row.owner_id} state={row}>
            //             {row.owner_name}
            //         </Link>
            //     )
            // },
        );
    } else {
        //for mobile device
        header.push(
            {
                title: "Info",
                prop: "offer_name_label",
                isFilterable: true,
                isSortable: true,
                cell: (row) => (
                    <div className="mobilecard">
                        <Link
                            to={`${ROUTES.ORDER_AMC.LIST}/${row.id}`}
                            state={row}
                            style={{ width: "100%" }}
                        >
                            {row.offer_name_label}
                        </Link>

                        <span>
                            <i className="fa-solid fa-phone"></i> {row.phone}
                        </span>
                        <span style={{ width: "80%" }}>
                            <i className="fa-solid fa-envelope"></i> {row.email}
                        </span>
                    </div>
                ),
            });
    }


    const labels = {
        beforeSelect: " ",
    };

    const createOrderAmc = () => {
        navigate(ROUTES.ORDER_AMC.CREATE);
    };

    const handleChange = (e) => {//For Filteration Work.
        setFilterData((pre) => ({ ...pre, [e.target.name]: e.target.value }));
    };

    //For Searching Filteration.

    const handleSearch = async (e) => {
        console.log("Leaad", filterData);
        const result = await fuziElevatorsApi.fetchAllFilterRecordsAMC(filterData);
        console.log("result", result);
        setBody([...result]);
    };

    //For Searching Filteration Clear.
    const handleClear = () => {
        setFilterData({});
        setAmcUptoDateRange([]);
        fetchOrderAmcs();
        // fetchLeads();
        // handleSearch();
    };

    const getStatusClass = (status) => {
        const statusObj = constants.AMC_STATUS_VALUES.find(
            (value) => value.label === status
        );
        return statusObj ? statusObj.css : {};
    };

    const customFilter = (rows, filters) => {
        return rows.filter((row) => {
            return Object.keys(filters).every((column) => {
                const filterValue = filters[column]?.toLowerCase() || "";
                if (!filterValue) return true; // filter empty hai to row include karo

                const rowValue = row[column]?.toString().toLowerCase() || "";
                return rowValue.includes(filterValue); // substring + case-insensitive
            });
        });
    };

    //Added by shahir hussain for change user 31-12-2025
    useEffect(() => {
        (async () => {
            try {
                const fetchUsers = await fuziElevatorsApi.fetchUsersForListPage();
                if (Array.isArray(fetchUsers)) {
                    setUsers(fetchUsers?.map(({ id, username, userrole }) => ({ value: id, label: `${username} - ${userrole}` })));
                } else {
                    setUsers([]);
                }
            } catch (error) {
                console.error("Failed to load users/contacts:", error);
                setUsers([]);
            }
        })();
    }, []);

    //Added by shahir hussain for change user 31-12-2025
    useEffect(() => {
        (async () => {
            if (fromUser && fromUser?.value) {
                setSpinnerForChangeOwner(true);
                const leads = await fuziElevatorsApi.getOrderAMCByStaffId(fromUser?.value);
                if (leads.success) {

                    setOwnerLeads(leads?.data);
                    setOwnerLeadsHeader([
                        {
                            title: <Form.Check // prettier-ignore
                                type={"checkbox"}
                                label="Select All"
                                name="all_leads"
                                onChange={handelCheckBox}
                            />,
                            prop: "id",
                            isFilterable: true,
                            cell: (row) => (
                                <Form.Check // prettier-ignore
                                    type={"checkbox"}
                                    id={`${row.id}`}
                                    name="leads"
                                />
                            ),
                        },
                        {
                            title: "Order",
                            prop: "offer_name_label",
                            isFilterable: true,
                            cell: (row) => (
                                <Link to={"/order_amcs/" + row.id} state={row}>
                                    {row.offer_name_label}
                                </Link>
                            ),
                        },
                        {
                            title: "AMC Status",
                            prop: "amc_status",
                            isFilterable: true, isSortable: true,
                            // cell: (row) => {
                            //   return (
                            //     <Badge bg={getStatusClass(row.lead_status)} style={{ display: "block", paddingBottom: "5px" }}>
                            //       {row.lead_status}
                            //     </Badge>
                            //   );

                            // },
                        },
                        {
                            title: "Created Date", prop: "createddate", isSortable: true, isFilterable: true, cell: (row) => (
                                <span>
                                    {moment(row.createddate).format('DD-MM-yyyy')}
                                </span>
                            )
                        },
                        {
                            title: "Assigned",
                            prop: "ownername",
                            isFilterable: true,
                            isSortable: true,
                            cell: (row) => {
                                const titleAbbreviations = {
                                    "Sales Admin": "S. S.",
                                    "Installation Admin": "I. A.",
                                    "Accounts": "ACCOUNTS",
                                    "Accounts Admin": "A. A.",
                                    "Installation Engineer": "I. E.",
                                    "Installation Supervisor": "I. S.",
                                    "Business Development Executive": "B. D. E.",
                                    "Customer Relationship Executive": "C. R. E.",
                                    "Office": "OFFICE",
                                    "Office Coordinator": "O. C.",
                                    "Office Executive": "O. E.",
                                    "Service Admin": "S. R.",
                                    "SUPER_ADMIN": "SUPER_ADMIN" // If no abbreviation is needed
                                };


                                const ownerNames = row.ownername ? row.ownername.split(', ') : [];
                                const ownerIds = row.ownerid ? row.ownerid : [];

                                const shortenTitle = (name) => {
                                    const [fullName, title] = name.split(' - ');
                                    const shortTitle = titleAbbreviations[title.trim()] || title; // Use abbreviation if available
                                    return `${fullName} - ${shortTitle}`;
                                };

                                const links = ownerNames.map((name, index) => (
                                    <Link
                                        key={index}
                                        to={`/users/${ownerIds[index]}`}
                                        state={row}
                                        className="align-items-center justify-content-start"
                                    >
                                        {shortenTitle(name)}<br />
                                    </Link>
                                ));
                                return <span>{links}</span>;
                            },
                        },
                    ]);
                }
                else {
                    setOwnerLeads([]);
                    setOwnerLeadsHeader([]);
                }
                setSpinnerForChangeOwner(false);
            } else {
                setOwnerLeads([]);
                setOwnerLeadsHeader([]);
            }
        })();
    }, [fromUser])

    //Added by shahir hussain for change user 31-12-2025
    const handelChangeOwnerModalClose = () => {
        setChangeOwnerModal(false);
        setRefreshRecords(!(refreshRecords));
        setOwnerLeads([]);
        setOwnerLeadsHeader([]);
        setFromUser({});
        setToUser({});
        setSelectedToUsers([])
    }

    //Added by shahir hussain for change user 31-12-2025
    const ChangeOwner = (e) => {
        e.preventDefault();
        let leads = [...(tableRef?.current?.querySelectorAll(`input[name='leads']`))];
        leads = leads?.filter((elm) => (elm.checked));
        leads = leads?.map((elm) => (elm.id));

        const toUsers = selectedToUsers.map(u => u.value);
        (async () => {
            const result = await fuziElevatorsApi.ChangeOrderAMCOwner({ fromUser: fromUser.value, toUser: toUsers, leads });
            if (result.success) {
                PubSub.publish('RECORD_SAVED_TOAST', { title: 'Transfer Owner', message: 'Owner Transfer successfully' });
                setSelectedToUsers([]);
                handelChangeOwnerModalClose();
            } else {
                PubSub.publish('RECORD_ERROR_TOAST', { title: 'Transfer Owner Error', message: 'Some error occurred' });
            }
        })();
    }

    const handelCheckBox = (e) => {
        [...(tableRef.current.querySelectorAll(`input[name='leads']`))].forEach((elm) => {
            elm.checked = e.target.checked;
        })
    }
    //Added by shahir hussain for change user 31-12-2025
    const handelFromUserSelect = (e) => {
        if (e) {
            setFromUser(e);
        }
        else {
            setFromUser(e);
        }
    }

    return (
        <Container fluid>
            <DatatableWrapper
                body={(body && Array.isArray(body)) ? body : []}
                headers={header}
                paginationOptionsProps={{
                    initialState: {
                        rowsPerPage: 50,
                        options: [5, 10, 15, 20, 30, 50]
                    },
                }}
                filterFunction={customFilter}
            >
                <Row className="">
                    {/* <p style={{ fontSize: "22px", display: "flex", justifyContent: "center", fontWeight: "bold" }}>Search Filter</p> */}
                    <Col lg={2}>
                        <Form.Group className="mt-2" controlId="formBasicCourses">
                            <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicState"
                            >
                                Order
                            </Form.Label>

                            <Select
                                placeholder="Select your Order"
                                classNamePrefix="react-select"
                                className="z-3"
                                options={orderValues?.map((item) => ({
                                    value: item?.id,
                                    label: item?.name,
                                }))}
                                onChange={(e) => {
                                    handleChange({
                                        target: { name: "order_id", value: e.value },
                                    });
                                    handleChange({
                                        target: { name: "offer_name_label", value: e.label },
                                    });
                                }}
                                value={
                                    filterData?.order_id
                                        ? {
                                            value: filterData?.order_id,
                                            label: filterData?.offer_name_label,
                                        }
                                        : ""
                                }
                            ></Select>
                            <Form.Control.Feedback type="invalid">

                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col lg={2}>
                        <Form.Group className="mt-2" controlId="formBasicCourses">
                            <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicStatus"
                            >
                                AMC Status
                            </Form.Label>
                            <Form.Select
                                name="amc_status"
                                value={filterData?.amc_status || ""}
                                onChange={handleChange}
                            >
                                <option value="">--Select-Status--</option>
                                {statusArray.map((item, index) => (
                                    <option value={item.label} key={index}>
                                        {item.label}
                                    </option>
                                ))}
                            </Form.Select>

                            <Form.Control.Feedback type="invalid">

                            </Form.Control.Feedback>

                        </Form.Group>
                    </Col>
                    <Col lg={2}>
                        <Form.Group className="mt-2" controlId="formBasicCourses">
                            <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicPartsType"
                            >
                                Parts Type
                            </Form.Label>
                            <Form.Select
                                name="parts_type"
                                value={filterData?.parts_type || ""}
                                onChange={handleChange}
                            >
                                <option value="">--select type--</option>
                                {['With Parts', 'Without Parts'].map((value, index) => <option value={value} key={index}>{value}</option>)}

                            </Form.Select>
                            <Form.Control.Feedback type="invalid">

                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col lg={2}>
                        <Form.Group className="mt-2" controlId="formBasicCourses">
                            <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicPaymentStatus"
                            >
                                Payment Status
                            </Form.Label>
                            <Form.Select
                                name="payment_status"
                                value={filterData?.payment_status || ""}
                                onChange={handleChange}
                            >
                                <option value="">--select status--</option>
                                {['Pending', 'Due', 'Paid', 'Not Paid'].map((value, index) => <option value={value} key={index}>{value}</option>)}

                            </Form.Select>
                            <Form.Control.Feedback type="invalid">

                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col lg={2}>
                        <Form.Group className="mt-2" controlId="formBasicCourses">
                            <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicPaymentMode"
                            >
                                Payment Mode
                            </Form.Label>
                            <Form.Select
                                name="payment_mode"
                                value={filterData?.payment_mode || ""}
                                onChange={handleChange}
                            >
                                <option value="">--select mode--</option>
                                {['Monthly', 'Quarterly', 'Half Yearly', 'Yearly', 'One Time'].map((value, index) => <option value={value} key={index}>{value}</option>)}

                            </Form.Select>
                            <Form.Control.Feedback type="invalid">

                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col lg={2}>
                        <Form.Group className="mt-2" controlId="formBasicCourses">
                            <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicPaymentFrequency"
                            >
                                Payment Frequency
                            </Form.Label>
                            <Form.Select
                                name="payment_frequency"
                                value={filterData?.payment_frequency || ""}
                                onChange={handleChange}
                            >
                                <option value="">--select frequency--</option>
                                {constants?.PAYMENT_FREQUENCY_VALUES?.map((item, index) => <option value={item.value} key={index}>{item.label}</option>)}

                            </Form.Select>
                            <Form.Control.Feedback type="invalid">

                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>

                </Row>
                <Row className="align-items-end">
                    <Col>
                        <Filter classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }} />
                    </Col>
                    <Col
                        md={1}
                    >
                        <PaginationOptions labels={labels} />
                    </Col>

                    <Col>
                        <DateRangePicker
                            value={dateRange}
                            onChange={(e) => { setDateRange(e) }}
                            // format="dd/mm/yyyy"
                            character=" – "
                        />
                    </Col>
                    {/* Added by Imran Khan for AMC Upto Date Range on 25-02-2026 */}
                    <Col>
                        <Form.Label className="form-view-label">AMC Upto</Form.Label>
                        <DateRangePicker
                            value={amcUptoDateRange}
                            onChange={(e) => { setAmcUptoDateRange(e) }}
                            character=" – "
                            placeholder="AMC Upto Range"
                        />
                    </Col>
                    <Col className="py-1">
                        <BrowserView>
                            <div className="d-flex py-1 px-2 ">
                                <InfoPill left="Total" right={body?.length} rightClasses="bg-custom text-white border-white fw-bold" leftClasses="bg-white text-danger fw-bold " />
                            </div>
                        </BrowserView>
                    </Col>
                    <Col lg={2}>
                        <Form.Group className="mt-2" controlId="formBasicCourses">
                            <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicLeadManagerId"
                            >
                                Assigned User
                            </Form.Label>
                            <Select
                                // isClearable
                                className="z-3"
                                isMulti
                                name="owner_ids"
                                classNamePrefix="react-select"
                                onChange={(e) => {
                                    handleChange({
                                        target: { name: "owner_ids", value: e },
                                    });
                                }}
                                value={
                                    filterData?.owner_ids?.filter((item) => (item.value))
                                }
                                options={assignUsers}
                            />
                        </Form.Group>
                    </Col>
                    <Col
                        xs={12}
                        sm={6}
                        lg={4}
                        className="d-flex flex-col justify-content-end align-items-end"
                    >
                        <Stack direction="horizontal" gap={2}>
                            {/* Added by shahir hussain for change user 31-12-2025  */}
                            {userInfo?.userrole === "SUPER_ADMIN" && (
                                <Button onClick={() => (setChangeOwnerModal(true))} className="btn-sm" >Transfer Owner</Button>
                            )
                            }
                            {/* <Button variant="success" onClick={handleSearch}><i class="fas fa-search"></i></Button> */}
                            <Button variant="secondary" onClick={handleClear}><i class="fa fa-refresh" aria-hidden="true"></i></Button>
                            {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_AMC].some(permission => {
                                return userInfo?.permissions?.map(p => p.name).includes(permission);
                            }) && (
                                    <Button
                                        size="sm"
                                        className="btn-create"
                                        onClick={() => createOrderAmc(true)}
                                    >
                                        New Amc
                                    </Button>
                                )
                            }
                        </Stack>
                    </Col>
                </Row>

                {/* <Table striped className="shadow rounded sm my-4" responsive={true}>
                    <TableHeader classes={{ th: 'bg-custom text-white' }} />
                    {
                        (body && Array.isArray(body)) ?
                            <TableBody />
                            :
                            <tbody className="">
                                <tr>
                                    <td colSpan={100} align="center">
                                        <div>
                                            <Spinner />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                    }
                </Table> */}
                <div className="table-scroll my-3">
                    <Table striped className="shadow rounded sm my-4">
                        <TableHeader classes={{ th: 'bg-custom text-white sticky-header' }} />
                        {
                            (body && Array.isArray(body)) ?
                                <TableBody />
                                :
                                <tbody className="">
                                    <tr>
                                        <td colSpan={100} align="center">
                                            <div>
                                                <Spinner />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                        }
                    </Table>
                </div>
                <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
            </DatatableWrapper>
            {/* Added this modal by shahir hussain for change user 31-12-2025 */}
            {changeOwnerModal && <Modal
                show={changeOwnerModal}
                onHide={handelChangeOwnerModalClose}
                size={"xl"}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Transfer Owner
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={ChangeOwner} >
                    <Modal.Body >
                        <Row className="gap-3">
                            <Col lg={12} >
                                <Row className="">
                                    <Col lg={6}>
                                        <FormGroup>
                                            <FormLabel>From</FormLabel>
                                            <Select
                                                isClearable
                                                options={users}
                                                onChange={handelFromUserSelect}
                                                name="fromUser"
                                                required
                                            >
                                            </Select>
                                        </FormGroup>
                                    </Col>
                                    <Col lg={6}>
                                        <FormGroup>
                                            {/* <FormLabel>To</FormLabel>
                            <Select
                            isClearable
                            options={users}
                            onChange={handelToUserSelect}
                            name="toUser"
                            required
                            >
                            </Select> */}
                                            <UserMultiSelect
                                                options={users}
                                                value={selectedToUsers}
                                                onChange={setSelectedToUsers}
                                                label="To"
                                            />
                                        </FormGroup>
                                    </Col>

                                </Row>
                            </Col>
                            <Col lg={12} >
                            </Col>
                        </Row>
                        {(fromUser && Object.keys(fromUser)?.length > 0) &&
                            <Container style={{ height: "50vh", overflowY: "auto" }}>

                                {!spinnerForChangeOwner ?
                                    <DatatableWrapper
                                        body={ownerLeads}
                                        headers={ownerLeadsHeader}
                                    >
                                        <Table striped className="data-table" ref={tableRef}>
                                            <TableHeader />
                                            <TableBody />
                                        </Table>
                                    </DatatableWrapper>
                                    :
                                    <div className="d-flex justify-content-center align-items-center mt-5" >
                                        <Spinner animation="border" variant="secondary" size="lg" />
                                    </div>
                                }
                            </Container>
                        }


                    </Modal.Body>
                    <Modal.Footer>
                        <div className='submit'>
                            <Button variant="success" type="submit" >
                                Change
                            </Button>
                        </div>
                        <Button onClick={handelChangeOwnerModalClose} variant="light">
                            Close
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>}
        </Container>
    );
};

export default OrderAmcList;